import { useLayoutEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";

import OfferPageB from "@/components/OfferPageB";

function OfferPageBCorrected() {
  useLayoutEffect(() => {
    const wrongProductImage = document.querySelector<HTMLImageElement>(
      'img[src="/mockup-principal.png"]',
    );
    wrongProductImage?.parentElement?.remove();

    const offerSection = document.getElementById("oferta-b");
    if (!offerSection) return;

    const guaranteeText = Array.from(
      offerSection.querySelectorAll<HTMLSpanElement>("span"),
    ).find((span) => span.textContent?.trim().toLowerCase() === "7 dias de garantia");

    guaranteeText?.closest("div.flex.items-center")?.remove();
  }, []);

  return <OfferPageB />;
}

export const Route = createFileRoute("/oferta-b")({
  component: OfferPageBCorrected,
  head: () => ({
    meta: [
      { title: "100 Códigos do Amor — Direcionamento para o seu momento" },
      {
        name: "description",
        content:
          "Descubra o que mais está pesando no seu momento e receba um direcionamento prático para saber o que fazer hoje.",
      },
      { property: "og:title", content: "100 Códigos do Amor" },
      {
        property: "og:description",
        content:
          "Pare de perder sua paz por causa do amor. Entenda seu momento e receba uma direção prática para hoje.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "/oferta-b" }],
  }),
});
